import React from 'react'

import { Link } from 'react-router-dom'

import { Separator } from "../../components"

const Title = ({ children, prev, next, narrow, className = '', titleClassName = '', merchantHomeLink }) => {
    return (
        <>
            <div className={`container ${narrow ? 'container-center' : ''} title ${className}`}>
                <div className={`${(prev || next) ? 'd-flex justify-content-between' : ''}`}>
                    <div className="title-prev align-self-center">
                        { prev && <Link to={prev} />}
                    </div>
                    <h2 className={titleClassName}>
                    {merchantHomeLink && (
                      <span className="home-merchant-link pr-15">
                        <a href={merchantHomeLink} className="btn btn-link text-white">
                        <span className="material-symbols-outlined">home</span>
                      </a>
                      </span>
                    )}

                    {children}

                    </h2>
                    <div className="title-next align-self-center">
                        { next && <Link to={next} />}
                    </div>
                </div>
            </div>

            <Separator className={`title ml-0 mr-0 mt-4 d-none d-xl-block ${className}`} />
        </>
    )
}

export default Title
